import _ from 'lodash';
import { queryDowngradeLicenses } from '@/apis';
import { planTypes } from '@/common/constants';

const allowCallAssignApiPlanTypes = [
  planTypes.ZOOM_MEETING,
  planTypes.ZOOM_ROOMS,
  planTypes.ZOOM_EVENTS,
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
  planTypes.ADDITIONAL_HOST,
  planTypes.ADDITIONAL_CO_EDITOR,
  planTypes.TRANSLATION,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZOOM_CLIPS,
  planTypes.ZONE_PRO_PLUS,
  planTypes.ZOOM_REVENUE_ACCELERATOR,
  planTypes.CONCURRENCY_MEETING_BASIC,
  planTypes.CONCURRENT_MEETING_PLUS,
  planTypes.ZCM,
  planTypes.ZCM_STORAGE,
  planTypes.ZOOM_DOCS,
  planTypes.ZONE_EDU_PLUS,
  planTypes.VISITOR_MANAGEMENT,
  planTypes.WORKSPACE_RESERVATION,
];

const groupByPlanAssignInfo = (list = []) => {
  return _.reduce(list, (res, assignInfo = {}) => {
    return {
      ...res,
      [assignInfo.planCode]: assignInfo,
    };
  }, {});
};

/**
 *
 * @param plan
 * @return {Promise<AssignResultBean>}
 */
export const getAssignLicenseResult = async (plan = {}, planCodes) => {
  const { plan_code, type, isOneMonth = false } = plan;
  // OBT-5767: include webinar one-month in the case of [soft block modal]
  if (allowCallAssignApiPlanTypes.includes(type) && (!isOneMonth || (planTypes.WEBINAR === type && !!window.$query?.softWbnSub))) {
    const assignList = await queryDowngradeLicenses(planCodes || [plan_code]);
    return groupByPlanAssignInfo(assignList.result || []);
  }

  return {};
};
